import type { ComponentProps } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { ValidationDiffTable } from "../components/ValidationDiffTable";
import { setValidationTableFilterInRedux } from "../DrofusOccurrenceValidation/drofusOccurrenceValidationSlice";

export function ViewerValidationDiffTable({ table, ...props }: ComponentProps<typeof ValidationDiffTable> & {
  table: "articles" | "standardRoom";
}) {
  const dispatch = useAppDispatch();
  const filter = useAppSelector(state => state.drofusOccurrenceValidation.tableFilters[table]);
  return <ValidationDiffTable {...props} filter={filter}
    onFilterChange={value => dispatch(setValidationTableFilterInRedux({ table, ...value }))} />;
}
